"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Add a custom color": "Benutzerdefinierte Farbe hinzufügen",
  Apply: "Anwenden",
  "Apply color": "Farbe anwenden",
  Automatic: "Automatisch",
  Cancel: "Abbrechen",
  "Cancel color": "Farbe abbrechen",
  Change: "Ändern",
  Custom: "Benutzerdefiniert",
  "Custom color picker": "Benutzerdefinierte Farbauswahl",
  "Invalid hex value": "Ungültiger Hex-Wert",
  Remove: "Entfernen",
  "Select color {color}": ["Farbe ", ["color"], " auswählen"],
  "You’ve reached the {maxCustomColors} custom colors limit. To add another color, remove one first.": ["Sie haben das Limit von ", ["maxCustomColors"], " benutzerdefinierten Farben erreicht. Um eine weitere Farbe hinzuzufügen, entfernen Sie zuerst eine."]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map